import { createElement } from 'react';
import { redirect, RouteObject } from 'react-router-dom';

import { isHasAccess, pathPermissions, replacePermissions } from 'features/validateAccess';

import { calendarService, calendarStore } from 'entities/calendar';
import { queryClient } from 'shared/lib/react-query';
import { pathKeys } from 'shared/lib/react-router';

import CalendarLayoutPage from './CalendarLayoutPage';

export const calendarLayoutPageRoute: RouteObject = {
  path: ':calendarId/',
  element: createElement(CalendarLayoutPage),
  loader: async (args) => {
    const requiredPermissions = replacePermissions(pathPermissions.calendars.calendarLayout, args.params);
    if (!isHasAccess(requiredPermissions)) {
      return redirect(pathKeys.dashboard());
    }

    if (!args.params.calendarId) {
      return redirect(pathKeys.page404());
    }

    const year = calendarStore.getState().selectedYear;

    const calendar = await queryClient.fetchQuery(
      calendarService.queryOptions({
        id: args.params.calendarId,
        year: year.toString(),
      }),
    );

    if (calendar.archivedAt) {
      return redirect(pathKeys.page404());
    }

    return args;
  },
};
